import { useMutation } from "react-query";
import changeOnboardingStatus from "../services/changeOnboardingStatus";

const useChangeOnboardingStatus = () => {
  return useMutation(["change-onboarding-status"], changeOnboardingStatus);
};

export default useChangeOnboardingStatus;
